import * as React from 'react';

import { DropDownMenu, GridList, GridTile, MenuItem, SelectField, Chip } from 'material-ui';
import { blue300 } from 'material-ui/styles/colors';
import {
    SessionMode,
    SqlStudioSegment,
    StudioAppConfig,
    StudioCategory,
    SubscriptionStatus,
} from 'glance-datatypes';

import { BulkChangeData } from "../pages/drafts/types";
import { CSSProperties } from 'react';
import ChipInput from 'material-ui-chip-input';
import Utils from '../Utils';
import { connect } from 'react-redux';

const styles = {
    clickableChip: {
        margin: 1,
        display: 'inline-block',
    } as CSSProperties,
    width100: {
        width: '100%',
        maxWidth: 'none',
    } as CSSProperties
};
const SESSION_MODE_LIST = [{ name: 'LOCKSCREEN', value: SessionMode.DEFAULT }, { name: 'BINGE', value: SessionMode.BINGE }];
const CATEGORY_SOURCE_CONFIG = { text: 'displayName', value: 'category' };
const SESSION_MODE_CONFIG = { text: 'name', value: 'value' };

interface Props {
    studioAppConfig?: StudioAppConfig;
    bulkChangeData: BulkChangeData;
    onEdit: (target: string, value: any) => any;
}

interface CategorySource {
    displayName: string;
    category: StudioCategory;
}

interface SegmentSource {
    text: string;
    id: number;
}

const SEGMENT_SOURCE_CONFIG = { text: 'text', value: 'id' };

interface State {
    categorySource: CategorySource[];
    categoryMap: Map<string, StudioCategory>;
    segmentSource: SegmentSource[];
}
const rendersessionPropertiesMapping = (params) => {
    let data = Utils.getRenderSessionData(params);
    return SESSION_MODE_LIST.filter(item => data.includes(item.value));
}

class GlanceChangeData extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.handleRenderSessionModeChange = this.handleRenderSessionModeChange.bind(this);
        this.handleSkipSummaryChange = this.handleSkipSummaryChange.bind(this);
        this.handleShouldUnlock = this.handleShouldUnlock.bind(this);
        this.handleSdkSubscribedCategoriesFilterChange = this.handleSdkSubscribedCategoriesFilterChange.bind(this);
        this.handleTargetForCategoryChange = this.handleTargetForCategoryChange.bind(this);
        this.handleCategoryChange = this.handleCategoryChange.bind(this);

        const categorySource = [];
        const categoryMap = new Map<string, StudioCategory>();
        this.state = {
            categorySource: categorySource,
            categoryMap: categoryMap,
            segmentSource: [],
        };
    }

    componentDidMount() {
        const categorySource = [];
        const categoryMap = new Map<string, StudioCategory>();
        const { studioAppConfig } = this.props;
        studioAppConfig.categories.forEach(category => {
            categorySource.push({
                displayName: category.displayName,
                category: category,
            } as CategorySource);
            categoryMap.set(category.id, category);
        });
        this.setState((state, props) => ({
            categorySource: categorySource,
            categoryMap: categoryMap,
            segmentSource: [],
        }));
    }

    handleGlanceUserAgeFilterChange = async (value, type) => {
        const selectedDay = value;
        await this.props.onEdit(type, selectedDay);
        if (type === 'startDay') {
            this.props.onEdit('endDay', null);
        }
    }

    handleRenderSessionModeChange(chip: any, remove: boolean) {
        if (!chip) return;
        let renderProperties = rendersessionPropertiesMapping(this.props.bulkChangeData);
        if (remove) {
            renderProperties = renderProperties.filter(item => {
                return item.value !== chip;
            })
        } else {
            renderProperties.push(chip);
        }
        let renderSessionList = [];
        renderProperties.forEach(ele => {
            renderSessionList.push(ele.value);
        })
        this.props.onEdit('renderSessionProperties', renderSessionList)
    }

    handleSkipSummaryChange(field, context, value) {
        this.props.onEdit('canSkipSummary', value);
    }

    handleShouldUnlock(field, context, value) {
        this.props.onEdit('shouldUnlock', value);
    }

    handleSdkSubscribedCategoriesFilterChange(field, context, value) {
        this.props.onEdit('categorySubscriptionStatus', value);
    }

    handleTargetForCategoryChange(chip: any, remove: boolean) {
        console.log('handleTargetForCategoryChange', chip, remove);
        let newCategories = this.props.bulkChangeData ? this.props.bulkChangeData.targetForCategories : null;
        if (remove) {
            if (!newCategories) {
                return;
            }
            newCategories = newCategories.filter(function (category) {
                return category != chip.id;
            });

            this.props.onEdit('targetForCategories', newCategories);
        } else {
            if (!newCategories) {
                newCategories = [];
            }

            if (newCategories.indexOf(chip.category.id) == -1 && this.state.categoryMap.has(chip.category.id)) {
                newCategories = [...newCategories, chip.category.id];
                this.props.onEdit('targetForCategories', newCategories);
            }
        }
    }

    handleCategoryChange(chip: any, remove: boolean) {
        console.log('handleCategoryChange', chip, remove);
        let newCategories = this.props.bulkChangeData ? this.props.bulkChangeData.categoryIds : null;
        if (remove) {
            if (!newCategories) {
                return;
            }
            newCategories = newCategories.filter(function (category) {
                return category != chip.id;
            });

            if (newCategories.length == 0) {
                newCategories = null;
            }

            this.props.onEdit('categoryIds', newCategories);
        } else {
            if (!newCategories) {
                newCategories = [];
            }
            if (newCategories.length >= 2) {
                console.error('More than two not allowed');
                return;
            }
            if (newCategories.indexOf(chip.category.id) == -1 && this.state.categoryMap.has(chip.category.id)) {
                newCategories = [...newCategories, chip.category.id];
                this.props.onEdit('categoryIds', newCategories);
            }
        }
    }

    handleSegmentChange(chip: any, remove: boolean) {
        let newSegments = this.props.bulkChangeData ? this.props.bulkChangeData.segments : null;
        if (remove) {
            if (!newSegments) {
                return;
            }
            newSegments = newSegments.filter(function (segment) {
                return segment.id != chip;
            });
            if (newSegments.length == 0) {
                newSegments = null;
            }
            this.props.onEdit('segmentIds', newSegments);
        } else {
            if (!newSegments) {
                newSegments = [];
            }
            if (!newSegments.find(segment => segment.id == chip.id)) {
                let chipSegment = this.props.studioAppConfig.sqlSegments.find(s => s.id == chip.id);
                newSegments = [...newSegments, chipSegment];
                this.props.onEdit('segmentIds', newSegments);
            }
        }
    }

    convertSegmentsToSegmentSources(segments: SqlStudioSegment[]) {
        let segmentSource: SegmentSource[] = [];
        if (!segments) {
            return segmentSource;
        }

        segments.forEach((segment) => {
            segmentSource.push({
                text: segment.name + ' / ' + segment.displayName,
                id: segment.id,
            } as SegmentSource);
        });
        return segmentSource;
    }

    onSegmentSearch(chip: any) {
        let segments = this.props.studioAppConfig.sqlSegments;
        let segmentSourceTemp = this.convertSegmentsToSegmentSources(
            segments.filter((segment) => {
                return segment.name.toLowerCase().indexOf(chip.toLowerCase()) != -1 || segment.displayName.toLowerCase().indexOf(chip.toLowerCase()) != -1;
            }));
        segmentSourceTemp = segmentSourceTemp.slice(0, 10);
        this.setState({
            ...this.state,
            segmentSource: segmentSourceTemp,
        });
    }

    render() {
        let elements = [];
        const { bulkChangeData } = this.props;
        const userLifeTimeFilter = bulkChangeData && bulkChangeData.userLifeTimeFilter || { startDay: null, endDay: null };
        const startDay = (userLifeTimeFilter && userLifeTimeFilter.startDay) || 1;
        const startDays = Array.from(Array(8).keys()).map(stDay => stDay + 1);
        const endDays = startDays.filter(age => age >= startDay && age < 8);
        const categoryMap = [];
        this.props.studioAppConfig.categories.forEach(category => {
            categoryMap.push(
                <MenuItem
                    key={category.id}
                    value={category.id}
                    primaryText={'Not Subscribed To ' + category.displayName}
                />,
            );
        });

        const segments = (
            <ChipInput
                key='segments'
                hintText={'Segments'}
                style={{ ...styles.width100, marginTop: '-8px' }}
                value={this.convertSegmentsToSegmentSources(
                    this.props.bulkChangeData && this.props.bulkChangeData.segments != null
                        ? this.props.bulkChangeData.segments : null)}
                dataSource={this.state.segmentSource}
                dataSourceConfig={SEGMENT_SOURCE_CONFIG}
                onUpdateInput={(chip) => this.onSegmentSearch(chip)}
                onRequestAdd={(chip) => this.handleSegmentChange(chip, false)}
                onRequestDelete={(chip, index) => this.handleSegmentChange(chip, true)}
            />
        );


        const userAgeFilterTpl = (
            <GridList cellHeight='auto'>
                <GridTile>
                    <SelectField value={userLifeTimeFilter && userLifeTimeFilter.startDay ?
                        userLifeTimeFilter.startDay : null}
                        onChange={(field, context, value) => this.handleGlanceUserAgeFilterChange(value, 'startDay')}>
                        <MenuItem key='data-startDay--1' value={null} primaryText='All Users' />
                        {startDays.map(startDay =>
                            (<MenuItem key={`data-startDay-${startDay}`} value={startDay} primaryText={`${startDay <= 7 ? startDay : `${startDay - 1}+`}`} />))}
                    </SelectField>
                </GridTile>

                <GridTile>
                    <SelectField value={userLifeTimeFilter && userLifeTimeFilter.endDay ?
                        userLifeTimeFilter.endDay : null}
                        disabled={!userLifeTimeFilter.startDay || userLifeTimeFilter.startDay === 8}
                        onChange={(feild, context, value) => this.handleGlanceUserAgeFilterChange(value, 'endDay')}>
                        <MenuItem key='data-endDay--1' value={null} primaryText='End Day' />
                        {endDays.map(endDay =>
                            (<MenuItem key={`data-endDay-${endDay}`} value={endDay} primaryText={endDay} />))}

                    </SelectField>
                </GridTile>
            </GridList>
        );

        const sessionMode = (
            <div>Session Mode:
                <ChipInput
                    key='renderSessionProperties'
                    style={{ ...styles.width100 }}
                    value={rendersessionPropertiesMapping(this.props.bulkChangeData)}
                    dataSource={SESSION_MODE_LIST}
                    dataSourceConfig={SESSION_MODE_CONFIG}
                    onRequestAdd={(chip) => this.handleRenderSessionModeChange(chip, false)}
                    onRequestDelete={(chip) => this.handleRenderSessionModeChange(chip, true)}
                />
            </div>
        );

        const canSkipSummary = (
            <DropDownMenu
                value={
                    this.props.bulkChangeData && this.props.bulkChangeData.canSkipSummary != null
                        ? this.props.bulkChangeData.canSkipSummary
                        : null
                }
                key={'skip_summary_changer'}
                onChange={this.handleSkipSummaryChange}
            >
                <MenuItem key='Turn Off' value={null} primaryText='Skip Summary Turned Off' />
                <MenuItem key='Any' value={true} primaryText='Can Skip Summary' />
                <MenuItem key='Binge' value={false} primaryText='Cannot Skip Summary' />
            </DropDownMenu>
        );

        const shouldUnlock = (
            <DropDownMenu
                value={
                    this.props.bulkChangeData && this.props.bulkChangeData.shouldUnlock != null
                        ? this.props.bulkChangeData.shouldUnlock
                        : null
                }
                key={'peek_cta'}
                onChange={this.handleShouldUnlock}
            >
                <MenuItem key='Turn Off' value={null} primaryText='CTA Position Turned Off' />
                <MenuItem key='Any' value={true} primaryText='CTA After Unlock' />
                <MenuItem key='Binge' value={false} primaryText='CTA On Lockscreen' />
            </DropDownMenu>
        );

        const sdkSubscribedCategoriesFilter = (
            <DropDownMenu
                value={
                    this.props.bulkChangeData && this.props.bulkChangeData.categorySubscriptionStatus != null
                        ? this.props.bulkChangeData.categorySubscriptionStatus
                        : null
                }
                onChange={this.handleSdkSubscribedCategoriesFilterChange}
            >
                <MenuItem key='null' value={null} primaryText='Subscribed Status Turned Off' />
                <MenuItem
                    key={SubscriptionStatus.ANY}
                    value={SubscriptionStatus.ANY}
                    primaryText='SDK Subscribed Categories At Least 1'
                />
                <MenuItem
                    key={SubscriptionStatus.NONE}
                    value={SubscriptionStatus.NONE}
                    primaryText='SDK Subscribed Categories None'
                />
            </DropDownMenu>
        );

        const targetForCategoriesValue = [];
        if (this.props.bulkChangeData && this.props.bulkChangeData.targetForCategories) {
            this.state.categorySource.forEach((categorySource) => {
                if (this.props.bulkChangeData.targetForCategories.indexOf(categorySource.category.id) != -1) {
                    targetForCategoriesValue.push(categorySource);
                }
            });
        }

        const targetForCategory = (
            <ChipInput
                key='targetForCategories'
                hintText={'Not Subscribed to Categories'}
                style={{ ...styles.width100, marginTop: '-8px' }}
                value={targetForCategoriesValue}
                dataSource={this.state.categorySource}
                dataSourceConfig={CATEGORY_SOURCE_CONFIG}
                onRequestAdd={(chip) => this.handleTargetForCategoryChange(chip, false)}
                onRequestDelete={(chip, index) => this.handleTargetForCategoryChange(chip, true)}
            />
        );

        const categoriesValue = [];
        if (this.props.bulkChangeData && this.props.bulkChangeData.categoryIds) {
            this.state.categorySource.forEach(categorySource => {
                if (this.props.bulkChangeData.categoryIds.indexOf(categorySource.category.id) != -1) {
                    categoriesValue.push(categorySource);
                }
            });
        }

        const categories = (
            <ChipInput
                key='categoryIds'
                hintText={'Category'}
                style={{ ...styles.width100, marginTop: '-8px' }}
                value={categoriesValue}
                dataSource={this.state.categorySource}
                dataSourceConfig={CATEGORY_SOURCE_CONFIG}
                onRequestAdd={chip => this.handleCategoryChange(chip, false)}
                onRequestDelete={(chip, index) => this.handleCategoryChange(chip, true)}
            />
        );

        const advancedCta = (
            <Chip
                style={{ marginTop: '4px' }}
                key={'load_android_js'}
                backgroundColor={this.props != null 
                                    && this.props.bulkChangeData != null
                                    && this.props.bulkChangeData.advancedCta 
                                ? blue300 : null}
                onTouchTap={() => {
                    this.props.onEdit('advancedCta', !(this.props != null 
                        && this.props.bulkChangeData != null
                        && this.props.bulkChangeData.advancedCta ));
                }}
            >
                {this.props != null 
                  && this.props.bulkChangeData != null
                  && this.props.bulkChangeData.advancedCta 
                    ? 'Advanced CTA webview'
                    : 'Not advanced CTA webview'}
            </Chip>
        );


        elements.push(userAgeFilterTpl);
        elements.push(sessionMode);
        elements.push(canSkipSummary);
        elements.push(shouldUnlock);
        elements.push(sdkSubscribedCategoriesFilter);
        elements.push(targetForCategory);
        elements.push(categories);
        elements.push(segments);
        elements.push(advancedCta);

        return (
            <div>
                <form className='form'>{elements}</form>
            </div>
        );
    }
}



const mapStateToProps = (state) => {
    return {
        studioAppConfig: state.studioAppConfig,
    };
};


export default connect(mapStateToProps)(GlanceChangeData);



// WEBPACK FOOTER //
// ./src/components/GlanceChangeData.tsx